/* unplugin-vue-components disabled */import { render } from "./mapRegion.vue?vue&type=template&id=456074bb&scoped=true"
import script from "./mapRegion.vue?vue&type=script&lang=js"
export * from "./mapRegion.vue?vue&type=script&lang=js"

import "./mapRegion.vue?vue&type=style&index=0&id=456074bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456074bb"]])

export default __exports__